import { render } from "./Application.vue?vue&type=template&id=8b7c86f4&ts=true"
import script from "./Application.vue?vue&type=script&lang=ts"
export * from "./Application.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__